const state = {
  priceSortOrder: 'increasing',
  outwardFlightDepartureDelta: { begin: 0, end: 24 },
  returnFlightDepartureDelta: { begin: 0, end: 24 },
  schedulesFilterValidity: true,
  stopover: [
    {
      value: 'direct',
      name: 'direct'
    },
    {
      value: 'onestopover',
      name: 'one-stopover'
    },
    {
      value: 'manystopover',
      name: 'many-stopover'
    }
  ],
  selectedStopover: 'manystopover',
  selectedAirlineCompanies: []
}

const mutations = {
  setPriceSortOrder (state, newPriceSortOrder) {
    state.priceSortOrder = newPriceSortOrder
  },
  setOutwardFlightDepartureDelta (state, newHourDelta) {
    state.outwardFlightDepartureDelta = newHourDelta
  },
  setReturnFlightDepartureDelta (state, newHourDelta) {
    state.returnFlightDepartureDelta = newHourDelta
  },
  setSchedulesFilterValidity (state, validity) {
    state.schedulesFilterValidity = validity
  },
  setSelectedStopover (state, newStopoverState) {
    state.selectedStopover = newStopoverState
  },
  setSelectedAirlineCompanies (state, newCompaniesList) {
    state.selectedAirlineCompanies = newCompaniesList
  }
}

const getters = {
  getAirlineCompanies (state, getters, rootState) {
    const savedCompanies = []
    const companies = []

    for (const groupPrice of rootState.fb.searchResults.itineraries) {
      for (const itinerary of groupPrice.itinerary) {
        for (const segment of itinerary.flight_outward.segments) {
          if (savedCompanies.indexOf(segment.marketing_carrier) === -1) {
            savedCompanies.push(segment.marketing_carrier)
            companies.push({ name: segment.marketing_carrier_name, iata: segment.marketing_carrier })
          }
        }
        if (itinerary.flight_return) {
          for (const segment of itinerary.flight_return.segments) {
            if (savedCompanies.indexOf(segment.marketing_carrier) === -1) {
              savedCompanies.push(segment.marketing_carrier)
              companies.push({ name: segment.marketing_carrier_name, iata: segment.marketing_carrier })
            }
          }
        }
      }
    }
    return companies
  }
}

const actions = {
  resetStates ({ commit }) {
    commit('setPriceSortOrder', 'increasing')
    commit('setOutwardFlightDepartureDelta', { begin: 0, end: 24 })
    commit('setReturnFlightDepartureDelta', { begin: 0, end: 24 })
    commit('setSchedulesFilterValidity', true)
    commit('setSelectedStopover', null)
    commit('setSelectedAirlineCompanies', [])
  },
  resetFiltersStates ({ commit }) {
    commit('setPriceSortOrder', 'increasing')
    commit('setOutwardFlightDepartureDelta', { begin: 0, end: 24 })
    commit('setReturnFlightDepartureDelta', { begin: 0, end: 24 })
    commit('setSelectedStopover', 'manystopover')
    commit('setSelectedAirlineCompanies', [])
  },
  switchPriceSortOrder ({ state, commit }) {
    if (state.priceSortOrder === 'increasing') {
      commit('setPriceSortOrder', 'decreasing')
    } else if (state.priceSortOrder === 'decreasing') {
      commit('setPriceSortOrder', 'increasing')
    }
  },
  initSelectedAirlineCompanies ({ commit, getters }) {
    const initArray = []
    for (const airlineCompany of getters.getAirlineCompanies) {
      initArray.push(airlineCompany.iata)
    }
    commit('setSelectedAirlineCompanies', initArray)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
